import React from 'react';

const Banner = (props: { id?: string, children: React.ReactChild; }) => {
  return (
    <div
      data-locator='banner'
      id={props.id}
      className="w-auto text-sm text-left mb-4 p-2 mt-6 text-white bg-secondary rounded-lg opacity-75">
      {props.children}
    </div>);
};
export default Banner;
